import './WebShare.scss'

import { RWebShare } from 'react-web-share'
import cn from 'classnames'

import { isInApp } from '../common/helpers/Mobile'

export default function WebShare({
  text = '',
  color = 'text-white',
  size = 'fs-6',
  iconFill = true,
  buttonClass,
  url = window.location.href
}) {
  return (
    <RWebShare
      data={{
        text,
        url
      }}
      disableNative={!isInApp()}
    >
      <button
        className={cn('web-share-button bg-transparent border-0', buttonClass)}
      >
        <i
          className={cn(
            'bi',
            iconFill ? 'bi-share-fill' : 'bi-share',
            color,
            size
          )}
        />
      </button>
    </RWebShare>
  )
}
